import React, { ReactElement } from 'react';
import isEqual from 'react-fast-compare';

import { PageHeaderMeta } from '@/components/PageHeaderMeta/PageHeaderMeta';
import useAddNotificationCountToTitle from '@/hooks/useAddNotificationCountToTitle';
import { useAppSelector } from '@/redux/hooks';
import { getBaseUrl } from '@/redux/modules/config';
import { getCategoryLandingPageBaseUrl } from '@/utils/urls';

const DiscoverCategoriesMeta = (): ReactElement => {
    const baseUrl = useAppSelector(getBaseUrl, isEqual);
    const canonical = `${baseUrl}${getCategoryLandingPageBaseUrl()}`;
    const title = useAddNotificationCountToTitle('Explore Categories on LiveAuctioneers');
    const description = 'Most followed categories in art, jewelry, fashion, and home decor';

    return (
        <PageHeaderMeta
            canonical={canonical}
            description={description}
            title={title}
        />
    );
};

export default DiscoverCategoriesMeta;
